<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-back-button slot="start"></ion-back-button>
    <ion-title>API Keys</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>

  <div sxPadding="medium" sxRow sxAlign="stretch" sxGap="10px">
    <div sxBackground="light" sxPadding="medium" sxRadius="medium" sxWidth="fill"
      class="flex flex-row items-center justify-between">
      <p class="m-0">Organisation Account ID</p>
      <div sxRadius="medium" sxBorderWidth="1px" sxBorderColor="one" sxPadding="medium">
        <p sxMargin="0" sxCursor="pointer" (click)="copy(activeAccountId)" sxRow sxAlign="center" sxColor="two">
          {{activeAccountId}} <ion-icon sxMargin="0 0 0 5px" name="clipboard-outline"></ion-icon></p>
      </div>
    </div>
  </div>

  <div sxWidth="fill" sxCol sxGap="10px" sxOverflow="scroll" sxHeight="full" sxPadding="medium">
    <div sxRow sxDistribution="spaceBetween" sxAlign="center" sxWidth="full">
      <h1 sxTextSize="medium" sxMargin="0 5px">Active Keys</h1>
      <div sxRow sxGap="5px">
        <super-button size="v-small" radius="medium" padding="8px 10px" iconEnd="add-outline"
          [permissionModule]="ApiModules.AuthKey" [permissionOperation]="ApiOperations.create"
          (click)="createKey()">Create Key
        </super-button>
      </div>
    </div>
    <div *ngFor="let authKey of authKeys">
      <div sxRow sxBackground="light" sxAlign="center" sxDistribution="spaceBetween" sxRadius="medium" sxGap="10px"
        class="p-4">
        <div>
          <h3 class="m-0" sxWidth="fill" sxCapitalize="">
            {{ authKey?.name }}
            <span sxColor="two" sxTextSize="small">{{
              authKey?.createTime | date : 'medium'
              }}</span>
          </h3>
          <p sxCursor="pointer" sxColor="two" sxWidth="fill" sxTextWeight="bold" (click)="copy(authKey?.tokenId)">
            Token ID: {{ authKey?.tokenId }}
            <ion-icon name="clipboard-outline"></ion-icon>
          </p>
        </div>

        <super-button [permissionModule]="ApiModules.AuthKey" [permissionOperation]="ApiOperations.delete"
          iconStart="trash-outline" confirmationTitle="Delete Auth Key?" type="clear" color="danger"
          [action]="deleteAuthKey.bind(this, authKey._id)">Delete
        </super-button>

      </div>
    </div>
  </div>

</ion-content>